import React from "react";
import { Grid, Form, TextArea } from 'semantic-ui-react';
import { InputField, DropDown } from 'KN-EU-Broker-Dashboard-UI';

const HeadertabForm4 = ({formData, onChange, onBlur}) => {
    const {
        contactName,
        contactEmailAddress,
        contactPhoneNumber,
        comment
    } = formData
    
    return ( 
        <Grid className="responsiveGridCss1" data-reducer="updateHeaderTab">
            <Grid.Row className="headerTabForm4Row">
                <Grid.Column>
                    <InputField 
                        label='Contact Name' 
                        value={contactName}
                        name="contactName"
                        onChange={onChange}
                        onBlur={onBlur}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField 
                        label='Contact Telephone' 
                        type="number"
                        value={contactPhoneNumber}
                        name="contactPhoneNumber"
                        onChange={onChange}
                        onBlur={onBlur}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField 
                        label='Contact Email' 
                        value={contactEmailAddress}
                        name="contactEmailAddress"
                        onChange={onChange}
                        onBlur={onBlur}
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Form className="commentsTextArea">
                    <label className="commentsLabel" style={{fontSize:'10px',fontWeight:'bold'}}>Comments/References</label>
                    <TextArea onChange={onChange} name="comment" onBlur={onBlur} value={comment} className="commentsInput" placeholder='Comments...' />
                </Form>
            </Grid.Row>
        </Grid>
     );
}
 
export default HeadertabForm4;